export const getNumber = (num: number | undefined, unit: string = ''): string => {
    if(num === null || num === undefined) return '-';
    if (!isNaN(Number(num))) return `${num} ${unit}`;
    return '-';
}